module.exports = __webpack_public_path__ + "static/media/sad_cloud.4f0a7e96.svg";